import React from 'react';

import CountryService from '../Services/CountryService';

class CountryText extends React.Component {
    constructor(props) 
    {
        super(props);
        this.state = {
            text:props.Code
        };
    }

    componentDidMount() {
        CountryService.GetAllCountryByCode(this.props.Code)
            .then(result => this.setState({ text: result.name }))
            .catch(error => this.setState({ text: "" }));
    }

    render() {
        return this.state.text;
    }
}

export default CountryText;